import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import useAuthStore from './store/authStore';
import AdminLogin from './pages/admin/Login';
import MemberLogin from './pages/member/Login';
import Register from './pages/Register';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import AdminDashboard from './pages/admin/Dashboard';
import AdminMeetings from './pages/admin/Meetings';
import AdminMinutes from './pages/admin/Minutes';
import AdminFinancial from './pages/admin/FinancialStatements';
import AdminGallery from './pages/admin/Gallery';
import AdminNews from './pages/admin/News';
import AdminLibrary from './pages/admin/Library';
import AdminUsers from './pages/admin/Users';
import AdminAgenda from './pages/admin/Agenda';
import MemberDashboard from './pages/member/Dashboard';
import MemberMeetings from './pages/member/Meetings';
import MemberMinutes from './pages/member/Minutes';
import MemberFinancial from './pages/member/FinancialStatements';
import MemberGallery from './pages/member/Gallery';
import MemberNews from './pages/member/News';
import MemberLibrary from './pages/member/Library';
import MemberAgenda from './pages/member/Agenda';
import MemberAIAssistant from './pages/member/AIAssistant';
import AdminLayout from './components/AdminLayout';
import MemberLayout from './components/MemberLayout';
import './App.css';

const PrivateRoute = ({ children, requiredRole }) => {
  const { isAuthenticated, user } = useAuthStore();
  
  if (!isAuthenticated) {
    return <Navigate to={requiredRole === 'admin' ? '/admin/login' : '/member/login'} />;
  }
  
  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to={user?.role === 'admin' ? '/admin' : '/member'} />;
  }
  
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/register" />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={
            <PrivateRoute requiredRole="admin">
              <AdminLayout><AdminDashboard /></AdminLayout>
            </PrivateRoute>
          } />
          <Route path="/admin/meetings" element={
            <PrivateRoute requiredRole="admin">
              <AdminLayout><AdminMeetings /></AdminLayout>
            </PrivateRoute>
          } />
          <Route path="/admin/minutes" element={
            <PrivateRoute requiredRole="admin">
              <AdminLayout><AdminMinutes /></AdminLayout>
            </PrivateRoute>
          } />
          <Route path="/admin/financial-statements" element={
            <PrivateRoute requiredRole="admin">
              <AdminLayout><AdminFinancial /></AdminLayout>
            </PrivateRoute>
          } />
          <Route path="/admin/gallery" element={
            <PrivateRoute requiredRole="admin">
              <AdminLayout><AdminGallery /></AdminLayout>
            </PrivateRoute>
          } />
          <Route path="/admin/news" element={
            <PrivateRoute requiredRole="admin">
              <AdminLayout><AdminNews /></AdminLayout>
            </PrivateRoute>
          } />
          <Route path="/admin/library" element={
            <PrivateRoute requiredRole="admin">
              <AdminLayout><AdminLibrary /></AdminLayout>
            </PrivateRoute>
          } />
          <Route path="/admin/users" element={
            <PrivateRoute requiredRole="admin">
              <AdminLayout><AdminUsers /></AdminLayout>
            </PrivateRoute>
          } />
          <Route path="/admin/agenda" element={
            <PrivateRoute requiredRole="admin">
              <AdminLayout><AdminAgenda /></AdminLayout>
            </PrivateRoute>
          } />
          
          {/* Member Routes */}
          <Route path="/member/login" element={<MemberLogin />} />
          <Route path="/member" element={
            <PrivateRoute requiredRole="member">
              <MemberLayout><MemberDashboard /></MemberLayout>
            </PrivateRoute>
          } />
          <Route path="/member/meetings" element={
            <PrivateRoute requiredRole="member">
              <MemberLayout><MemberMeetings /></MemberLayout>
            </PrivateRoute>
          } />
          <Route path="/member/minutes" element={
            <PrivateRoute requiredRole="member">
              <MemberLayout><MemberMinutes /></MemberLayout>
            </PrivateRoute>
          } />
          <Route path="/member/financial-statements" element={
            <PrivateRoute requiredRole="member">
              <MemberLayout><MemberFinancial /></MemberLayout>
            </PrivateRoute>
          } />
          <Route path="/member/gallery" element={
            <PrivateRoute requiredRole="member">
              <MemberLayout><MemberGallery /></MemberLayout>
            </PrivateRoute>
          } />
          <Route path="/member/news" element={
            <PrivateRoute requiredRole="member">
              <MemberLayout><MemberNews /></MemberLayout>
            </PrivateRoute>
          } />
          <Route path="/member/library" element={
            <PrivateRoute requiredRole="member">
              <MemberLayout><MemberLibrary /></MemberLayout>
            </PrivateRoute>
          } />
          <Route path="/member/ai-assistant" element={
            <PrivateRoute requiredRole="member">
              <MemberLayout><MemberAIAssistant /></MemberLayout>
            </PrivateRoute>
          } />
          <Route path="/member/agenda" element={
            <PrivateRoute requiredRole="member">
              <MemberLayout><MemberAgenda /></MemberLayout>
            </PrivateRoute>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;